import React from 'react';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const { loginGoogle } = useAuth();

  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      {/* Brand panel — full-bleed campus hero */}
      <div className="relative hidden overflow-hidden lg:flex lg:flex-col lg:justify-between">
        <img src="/school-building.jpg" alt="Holy Palace Multipurpose Institute campus" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-navy/85 via-navy/55 to-navy-dark/95" />
        <div className="relative flex items-center gap-4 p-12 pb-0">
          <img src="/hpmi-logo.webp" alt="HPMI crest" data-testid="login-brand-logo" className="h-16 w-16 rounded-full bg-white/95 p-1 shadow-lg ring-2 ring-gold/60" />
          <div>
            <p className="font-heading text-lg font-bold leading-tight text-white">HOLY PALACE</p>
            <p className="font-heading text-sm font-semibold text-white/80">MULTIPURPOSE INSTITUTE</p>
            <p className="text-[10px] uppercase tracking-[0.2em] text-gold">Admission Management</p>
          </div>
        </div>
        <div className="relative p-12 pt-0">
          <p data-testid="brand-affiliation-text" className="max-w-md font-heading text-2xl font-semibold leading-snug text-white">Affiliated to WBBSE &amp; WBCHSE, English Medium, Co-Educational</p>
          <p data-testid="brand-tagline-text" className="mt-4 text-xs uppercase tracking-[0.3em] text-white/50">Education . Beyond . Boundaries</p>
        </div>
      </div>

      {/* Auth panel — Staff only */}
      <div className="flex items-center justify-center bg-[#F5F7FB] p-6">
        <div className="w-full max-w-sm">
          <div className="mb-8 lg:hidden">
            <div className="relative mb-4 h-36 overflow-hidden rounded-2xl shadow-md">
              <img src="/school-building.jpg" alt="Holy Palace Multipurpose Institute campus" className="absolute inset-0 h-full w-full object-cover" />
              <div className="absolute inset-0 bg-navy/35" />
              <img src="/hpmi-logo.webp" alt="HPMI crest" data-testid="login-brand-logo-mobile" className="absolute bottom-3 left-3 h-14 w-14 rounded-full bg-white/95 p-0.5 shadow ring-2 ring-gold/60" />
            </div>
            <p className="font-heading text-lg font-bold text-navy">HOLY PALACE MULTIPURPOSE INSTITUTE</p>
          </div>
          <h2 className="font-heading text-2xl font-bold text-[#172033]">Staff Sign In</h2>
          <p className="mt-1 text-sm text-[#64748B]">Sign in to continue.</p>

          <button
            data-testid="google-login-button"
            onClick={loginGoogle}
            className="mt-6 flex w-full items-center justify-center gap-3 rounded-xl border border-[#E2E8F0] bg-white py-3 text-sm font-semibold text-[#172033] transition hover:border-[#CBD5E1] hover:shadow-sm"
          >
            <img alt="" src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" className="h-5 w-5" />
            Continue with Google
          </button>

          <p className="mt-4 text-center text-xs text-[#94A3B8]">Only authorised Office &amp; Management accounts can sign in.</p>
        </div>
      </div>
    </div>
  );
}
